import React from 'react';
import PropTypes from 'prop-types';
import { EndpointTopdeskRemoteSearcher } from 'client/components/Form/Select2Searchers';
import { ButtonWaiting } from 'client/components/Button/ButtonWaiting';

/**
 * @component EATDTesterAddTopdeskPerson
 * @description Component with a searcher to find and add TOPdesk Persons for testing EATD rules.
 */
class EATDTesterAddTopdeskPerson extends React.Component {
  static propTypes = {
    endpointId: PropTypes.string.isRequired,
    objectId: PropTypes.string,
    onAdd: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isAdding: PropTypes.bool,
  };

  static defaultProps = {
    objectId: '',
    isAdding: false,
  };

  handleClick = () => {
    const { objectId, isAdding, onAdd } = this.props;
    if (!objectId || isAdding) return;
    onAdd(objectId);
  };

  handleChange = value => {
    this.props.onChange(value || '');
  };

  render () {
    const { endpointId, objectId, isAdding } = this.props;
    return (
      <div className="input-group xs-mb-15">
        <EndpointTopdeskRemoteSearcher
          id="eatdTesterSelectTopdeskPerson"
          name="personId"
          endpointId={endpointId}
          forWhat="person"
          onChange={this.handleChange}
          options={{
            allowClear: true,
            placeholder: 'Search by TOPdesk person name or email',
            minimumInputLength: 1,
          }}
          defaultValue={objectId}
        />
        <span className="input-group-btn">
          <ButtonWaiting
            type="button"
            className="btn btn-primary"
            onClick={this.handleClick}
            disabled={!objectId || isAdding}
            isWaiting={isAdding}
          >
            <i className="icon icon-left mdi mdi-account-plus"></i>
            Add Person
          </ButtonWaiting>
        </span>
      </div>
    );
  }
}

export default EATDTesterAddTopdeskPerson; 